var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", [
        _vm._v("\n\t\t" + _vm._s(_vm.t("health", "Measurement", {})) + "\n\t")
      ]),
      _vm._v(" "),
      !_vm.person.measurementChartDetail
        ? _c("h3", [
            _vm._v("\n\t\t" + _vm._s(_vm.t("health", "Chart", {})) + "\n\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.person.measurementChartDetail
        ? _c("h3", [
            _vm._v("\n\t\t" + _vm._s(_vm.t("health", "Charts", {})) + "\n\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.person.measurementChartDetail
        ? _c("h4", [
            _vm._v(
              "\n\t\t" + _vm._s(_vm.t("health", "Over all view", {})) + "\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c("MeasurementChart", {
            attrs: { person: _vm.person, data: _vm.measurementData }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading ? _c("div", { staticClass: "icon-loading" }) : _vm._e(),
      _vm._v(" "),
      _vm.person.measurementChartDetail
        ? _c("h4", [
            _vm._v(
              "\n\t\t" + _vm._s(_vm.t("health", "Detail view", {})) + "\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.person.measurementChartDetail
        ? _c("MeasurementDetailChart", {
            attrs: { person: _vm.person, data: _vm.measurementData }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading && _vm.person.measurementChartDetail
        ? _c("div", { staticClass: "icon-loading" })
        : _vm._e(),
      _vm._v(" "),
      _c("h3", [_vm._v("Data")]),
      _vm._v(" "),
      !_vm.loading
        ? _c("MeasurementTable", {
            attrs: { data: _vm.measurementData, person: _vm.person }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading ? _c("div", { staticClass: "icon-loading" }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }